export default __webpack_public_path__ + "static/media/Large Grenade.0f9b8260.PNG";